import { makeObservable } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import type { FirebaseRepository } from './FirebaseRepository'
import {
  empty,
  type FirestoreSettingsDefaultProcessingAsset,
} from '../firestore/SettingsDefaultProcessingAsset'

export class SettingsDefaultProcessingAsset extends ObservableModelWithDecorators<FirestoreSettingsDefaultProcessingAsset> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreSettingsDefaultProcessingAsset>
  ) {
    super(repository, doc)

    makeObservable(this)
  }
}
